import List from "@material-ui/core/List";
import Grid from "@material-ui/core/Grid";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import { DRAWER_LIST } from "../constants/menu";
import MenuItem from "./MenuItem";
import { useEffect, useState } from "react";
import * as Actions from "../reducer-store/actions/communicationAction";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { MESSAGES_REFRESH_INTERVAL } from "../reducer-store/constants";

const useStyles = makeStyles((theme: Theme) => ({
  padding: {
    padding: 0,
  },
  icon: {
    padding: "12px 20px",
  },
}));

const MenuItemsList = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const AuthToken = useSelector((state: any) => state.auth);
  const { token } = AuthToken;
  const { UnreadCommunicationCount } = bindActionCreators(Actions, dispatch);
  const [count, setCount] = useState<any>(0);

  useEffect(() => {
    if (!token) {
      return;
    }

    let isMounted = true;

    const fetchUnreadCount = async () => {
      const resData: any = await UnreadCommunicationCount(token);
      if (isMounted) {
        setCount(resData?.data?.count ?? 0);
      }
    };

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, MESSAGES_REFRESH_INTERVAL);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [token]);

  return (
    <Grid>
      <List className={classes.padding}>
        {/* <IconButton
          color="inherit"
          onClick={() => toggleIsOpened(!isOpened)}
          className={`${classes.icon} drawer-icon`}
        >
          {isOpened ? <ArrowBack /> : <MenuIcon />}
        </IconButton> */}
        {DRAWER_LIST.map(({ literal, route, Icon }) => (
          < MenuItem
            Icon={Icon}
            literal={literal == "Communication" ? `Communication ${count > 0 ? `(${count})` : ""}` : literal}
            route={route}
            key={route}
            selected={pathname.includes(route) ? true : false}
          />
        ))}
      </List>
    </Grid>
  );
};

export default MenuItemsList;
